"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _cell = _interopRequireDefault(require("../cell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var getChecked = function getChecked(props, defaultChecked) {
  if (typeof props.checked !== 'undefined') {
    return props.checked;
  }

  if (typeof props.defaultChecked !== 'undefined') {
    return props.defaultChecked;
  }

  return defaultChecked;
};

var Radio =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Radio, _PureComponent);

  function Radio() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radio)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      checked: getChecked(_this.props, false)
    };

    _this.onValueChange = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;
      var checked = _this.state.checked;

      if (disabled) {
        return;
      }

      var newChecked = !checked;

      if (!('checked' in _this.props)) {
        _this.setState({
          checked: newChecked
        });
      }

      if (typeof onChange === 'function') {
        onChange(e);
      }
    };

    return _this;
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          type = _this$props2.type,
          value = _this$props2.value,
          disabled = _this$props2.disabled,
          id = _this$props2.id,
          children = _this$props2.children;
      var checked = this.state.checked;
      var cls = (0, _classnames2.default)(prefixCls, className, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "--checked"), !!checked), _defineProperty(_classnames, "".concat(prefixCls, "--disabled"), !!disabled), _defineProperty(_classnames, "".concat(prefixCls, "--untext"), !children), _classnames));

      var inputRender = _react.default.createElement("input", {
        id: id,
        type: "radio",
        className: "".concat(prefixCls, "__input"),
        value: value,
        disabled: disabled,
        checked: checked,
        onChange: this.onValueChange
      });

      var radioRender = _react.default.createElement("span", {
        className: cls
      }, _react.default.createElement("span", {
        className: "".concat(prefixCls, "__widget")
      }, _react.default.createElement("span", {
        className: "".concat(prefixCls, "__inner")
      })), children && _react.default.createElement("span", {
        className: "".concat(prefixCls, "__text")
      }, children), inputRender);

      if (type === 'cell') {
        return _react.default.createElement(_cell.default, {
          disabled: disabled,
          onClick: function onClick() {}
        }, radioRender);
      }

      if (type === 'button') {
        return _react.default.createElement("button", {
          type: "button",
          disabled: disabled,
          className: cls
        }, children, inputRender);
      }

      return radioRender;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if ('checked' in nextProps && nextProps.checked !== state.prevChecked) {
        return {
          checked: nextProps.checked,
          prevChecked: nextProps.checked
        };
      }

      return null;
    }
  }]);

  return Radio;
}(_react.PureComponent);

exports.default = Radio;
Radio.Group = void 0;
Radio.defaultProps = {
  prefixCls: 'za-radio',
  disabled: false,
  shape: 'radius'
};